<!--加班界面-->
<template>
    <div>
        <van-nav-bar :title="title"/>
        <div class="pm-panel" >
            <van-cell-group>
                <van-field
                        :required=true
                        :border=false
                        readonly
                        clickable
                        label="日期"
                        :value="formModel.date"
                        placeholder="请选择"
                        @click="showDatePicker = true"
                />
                <van-popup v-model="showDatePicker" position="bottom">
                    <van-datetime-picker
                            v-model="pickDate"
                            type="date"
                            :min-date="minDate"
                            :max-date="maxDate"
                            @cancel="showDatePicker = false"
                            @confirm="onDateConfirm"
                    />
                </van-popup>
            </van-cell-group>

            <van-cell-group>
                <van-field
                        v-model="formModel.remark"
                        rows="2"
                        autosize
                        label="备注"
                        type="textarea"
                        maxlength="50"
                        placeholder="请输入备注"
                        show-word-limit
                />
            </van-cell-group>
            <van-cell-group>
                <van-button style="margin-top: 10px;" type="primary"
                            block round color="#fe7844" :loading="isLoading"
                            loading-text="记录中..."
                            @click="submitForm">记录</van-button>
            </van-cell-group>
        </div>
    </div>

</template>

<script>


    import * as DateUtil from '@/common/utils/dateUtil.js'
    import * as MyApi from '@/api/URLApiAddr.js'
    import store from '@/store'

    export default {
        name: "WorkOvertime",
        data() {
            return {
                title: '加班记录',
                formModel: {
                    id:'',
                    userId: '',
                    remark: '',
                    date: DateUtil.formatDate(new Date,'yyyy-MM-dd'),
                },
                showPicker: false,
                showKeyboard: false,
                isLoading: false,
                showDatePicker: false,
                pickDate:new Date(),
                minDate: DateUtil.getMinDate(),
                maxDate: DateUtil.getMaxDate(),
            }
        },
        methods:{
            submitForm() {
                this.isLoading = true
                let user = store.state.sys.user
                let params = this.formModel
                params.userId = user.userId
                this.$axios.post(MyApi.RECORD_WORK_OVERTIME_URL,params/*,options*/)
                    // 请求成功后
                    .then((data) => {
                        //let data = response.data;
                        if('200' == data.code){
                            this.formModel.remark = ''
                            this.$toast.success(data.msg);
                        }
                        this.isLoading = false
                    })
                    .catch((err) => {
                        this.$toast.fail("请求异常,请稍后再试" + err);
                    })
            },
            onDateConfirm(value) {
                this.formModel.date = DateUtil.formatDate(value,'yyyy-MM-dd');
                this.showDatePicker = false;
            }
        }
    }
</script>

<style scoped>

</style>
